<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">Add a project </span>
    <button type="button" class="closeModal pull-right" (click)="onClose()" aria-label="Close">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <label class="sub-title-lable">Select to add a Packaging project or Product project</label>
    <div class="row">
      <div class="setPadding" *ngIf="showProjectEdit">
        <input
          class="radioColor"
          id="selectProject"
          type="radio"
          name="SelectProject"
          value="package"
          [checked]="selectedProject === 'package'"
          (change)="onChangeRadio($event)"
        />
        <span class="project-text">
          Packaging
          <img src="./assets/icons/Scenario-Icon-Purple.svg" width="23" height="23" class="icon"
        /></span>
      </div>
      <app-feature-lock
        [isDisabled]="isCheckProductAccessDisabled"
        [featureCode]="FeatureCodes.PREFERENCES_MATERIAL_CERTIFICATIONS"
        [popupPosition]="'bottom-right'"
      >
        <div
          class="setPadding"
          *ngIf="showProductEdit"
          [piqetAngularSectionAccess]="FeatureCodes.PRODUCT_PROJECT"
        >
          <input
            class="radioColor"
            id="selectProject"
            type="radio"
            name="SelectProject"
            value="product"
            [checked]="selectedProject === 'product'"
            (change)="onChangeRadio($event)"
          />
          <span class="project-text">
            Product
            <img src="./assets/icons/Product-Sidebar-Icon.svg" width="23" height="23" class="icon"
          /></span>
        </div>
      </app-feature-lock>
    </div>
  </div>

  <div class="modal-footer-add-project text-margin">
    <button type="button" class="btn btn-light cancel-btn modelBtn" (click)="onClose()">
      Cancel
    </button>
    <button type="button" class="btn next-btn modelBtn" (click)="createProject()">
      Next <i class="bi bi-arrow-right checkbox-div"></i>
    </button>
  </div>
</div>
